export default class ResizeFrames {

    static listen() {

        window.addEventListener('message', (e) => {
            let iframe = this.getFrameByEvent(e);

            if (iframe && e.data) {
                try {
                    let data = typeof e.data === 'object' ? e.data : JSON.parse(e.data);
                    if (typeof data !== 'undefined' && data.event && data.event === 'resize') {
                        iframe.style.height = data.height + 'px';
                    }
                    if (e.data.height) {
                        iframe.style.height = parseInt(e.data.height) + "px";
                    }
                } catch (e) {

                }
            }
        }, false);
    }

    static getFrameByEvent(event) {
        return Array.from(document.getElementsByTagName('iframe')).filter(iframe => {
            return iframe.contentWindow === event.source;
        })[0];
    }
}